<template>
  <FsForm class="form" :model="form" :rules="rules" ref="formRef">
    <p class="export-project__title">Base Info</p>
    <FsFormItem label="Title *" prop="title">
      <FsInput v-model="form.title" placeholder="Title" :maxlength="25" new-regular />
    </FsFormItem>
    <FsFormItem label="Solution Name *" prop="solutionName">
      <FsInput v-model="form.solutionName" placeholder="Solution Name" :maxlength="200" new-regular />
    </FsFormItem>
    <FsFormItem label="Solution Type *" prop="solutionType">
      <FsSelect v-model="form.solutionType" :options="typeOptions" new-regular />
    </FsFormItem>
    <FsFormItem label="Project Background *" prop="projectBackgroundDes">
      <FsInput
        type="textarea"
        v-model="form.projectBackgroundDes"
        placeholder="Project Background"
        :maxlength="1000"
        new-regular
      />
    </FsFormItem>
    <FsFormItem label="Industry *" prop="industryDes">
      <FsInput v-model="form.industryDes" placeholder="Industry" :maxlength="1000" new-regular />
    </FsFormItem>
    <FsFormItem label="Project Area *" prop="projectLocation">
      <FsSelect
        placeholder="Select project area"
        v-model="form.projectLocation"
        filterable
        search-placeholder="Search"
        :options="areaOptions"
        new-regular
      />
    </FsFormItem>

    <p class="export-project__title">Scheme Demand</p>
    <FsFormItem label="Device Demand *" prop="equipmentRequirementsDes">
      <FsInput v-model="form.equipmentRequirementsDes" placeholder="Device Demand *" :maxlength="5000" new-regular />
    </FsFormItem>
    <FsFormItem label="Function Demand *" prop="functionalRequirementsDes">
      <FsInput v-model="form.functionalRequirementsDes" placeholder="Function Demand" :maxlength="5000" new-regular />
    </FsFormItem>
    <FsFormItem label="Others" prop="otherRequirementsDes">
      <FsInput v-model="form.otherRequirementsDes" placeholder="Others" :maxlength="5000" new-regular />
    </FsFormItem>

    <p class="export-project__title">Scheme Describe</p>
    <FsFormItem label="Solution Framework Describe *" class="scheme_describe" prop="programmeDes">
      <FsInput
        type="textarea"
        v-model="form.programmeDes"
        placeholder="Solution Framework Describe"
        :maxlength="10000"
        new-regular
      />
    </FsFormItem>
    <!-- <FsFormItem label="Export Type" prop="exportType">
			<FsSelect v-model="form.exportType" :options="exportTypeOptions" />
		</FsFormItem> -->
  </FsForm>
  <div class="footer_btn">
    <FsButton type="red" size="mediumSmall" @click="exportClick" :loading="loading">Export PDF</FsButton>
    <button type="button" class="cancel_btn" @click.stop="emits('close')">Cancel</button>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { FsForm, FsFormItem, FsInput, FsSelect, FsButton } from 'fs-design'
import { uploadImage, getCountryList, exportCustomerPdf, exportTechnologyPdf } from '@/api/modules/project'
import { useWebsiteInfoStore } from '@/store/websiteInfo'
import { useProjectStore } from '@/store/project'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/user'
import { useProductSelectionStore } from '@/store/productSelection'
import { trackEvent } from '@/utils/analytics'
const productSelectionStore = useProductSelectionStore()

interface Option {
  label: string
  value: string
}

const formRef = ref()

const websiteInfoStore = useWebsiteInfoStore()
const userStore = useUserStore()
const projectStore = useProjectStore()
const { exportProjectId } = storeToRefs(projectStore)
const emits = defineEmits(['close'])
const form = ref({
  title: 'Customer Company',
  solutionName: '',
  solutionType: '1',
  projectBackgroundDes: '',
  industryDes: '',
  projectLocation: '',
  equipmentRequirementsDes: '',
  functionalRequirementsDes: '',
  otherRequirementsDes: '',
  programmeDes: '',
})

const rules = ref({
  title: [{ required: true, message: 'Please input title' }],
  solutionName: [{ required: true, message: 'Please input solution name' }],
  solutionType: [{ required: true, message: 'Please select solution type' }],
  projectBackgroundDes: [{ required: true, message: 'Please input project background description' }],
  industryDes: [{ required: true, message: 'Please input industry description' }],
  projectLocation: [{ required: true, message: 'Please select project area' }],
  equipmentRequirementsDes: [{ required: true, message: 'Please input equipment requirements description' }],
  functionalRequirementsDes: [{ required: true, message: 'Please input functional requirements description' }],
  otherRequirementsDes: [{ required: false }],
  programmeDes: [{ required: true, message: 'Please input solution design architecture description' }],
})

const areaOptions = ref<Option[]>([])
const loading = ref(false)
const typeOptions = ref([
  { label: 'Campus Network Solutions', value: '1' },
  { label: 'Data Center Solutions', value: '2' },
])

// const exportTypeOptions = ref([
// 	{ label: 'PDF', value: 'pdf' },
// 	{ label: 'Excel', value: 'excel' },
// 	{ label: 'Word', value: 'word' },
// ])

const exportClick = async () => {
  trackEvent({
    eventCategory: 'dec_topology',
    eventAction: 'pdf',
    eventLabel: 'export_pdf',
  })
  try {
    await formRef.value.validate()
    if (loading.value) {
      return
    }

    loading.value = true
    exportTechnologyPdf({
      solutionTitle: form.value.title,
      projectId: exportProjectId.value,
      solutionName: form.value.solutionName,
      solutionType: form.value.solutionType,
      projectBackgroundDes: form.value.projectBackgroundDes,
      industryDes: form.value.industryDes,
      projectLocation: form.value.projectLocation,
      equipmentRequirementsDes: form.value.equipmentRequirementsDes,
      functionalRequirementsDes: form.value.functionalRequirementsDes,
      otherRequirementsDes: form.value.otherRequirementsDes,
      programmeDes: form.value.programmeDes,
      productIdList: productSelectionStore.selectedProductIds,
    })
      .then((res: any) => {
        trackEvent({
          eventCategory: 'dec_topology',
          eventAction: 'pdf',
          eventLabel: 'pdf_generated',
        })
        console.log('--+++++')
        console.log(res.headers)
        console.log(res, 'res---')
        console.log(res.headers['content-disposition'])

        for (const key in res.headers) {
          if (res.headers.hasOwnProperty(key)) {
            console.log(`${key}: ${res.headers[key]}`)
          }
        }
        const contentDisposition = res?.headers['content-disposition']
        const match = contentDisposition?.match(/filename="?(.+?)"?$/)
        const filename = match ? decodeURIComponent(match[1]) : 'download.pdf'

        const blob = new Blob([res?.data], { type: 'application/pdf' })
        const blobUrl = URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = blobUrl
        link.download = filename
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(blobUrl)
        link.remove()
        emits('close')
        // loading.value = false
      })
      .catch(error => {
        trackEvent({
          eventCategory: 'dec_topology',
          eventAction: 'err',
          eventLabel: error,
        })
        loading.value = false
      })
  } catch (err) {
    console.log(err, 'err')
    loading.value = false
  }
}

const getCountry = () => {
  getCountryList().then((res: any) => {
    res.data.forEach((item: any) => {
      areaOptions.value.push({
        label: item.countryEn,
        value: item.countryEn,
      })
    })
  })
}

onMounted(() => {
  getCountry()
})
</script>

<style lang="scss" scoped>
.form {
  padding: 16px 20px 20px 20px;
  flex: 1 1 auto;
  overflow: auto;
}
.scheme_describe {
  margin-bottom: 0;
}

.footer_btn {
  padding: 20px 20px 24px 20px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row-reverse;

  .cancel_btn {
    @include textButton();
    margin-right: 16px;
  }
}
</style>
